import { useState, useEffect } from 'react';
import { Option } from '../../../types/common';

interface DropdownProps {
    label: string;
    options: Option[];
    selected: Option;
    onChange: (selectedOption: Option) => void;
}

const Dropdown = ({ label, options, onChange, selected }: DropdownProps) => {
    const [selectedOption, setSelectedOption] = useState<Option>(selected || options[0]);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        const selectedOption = options.find((option) => option.label === value);

        if (selectedOption) {
            setSelectedOption(selectedOption);
            onChange(selectedOption);
        }
    };

    useEffect(() => {
        setSelectedOption(selected || options[0]);
    }, [selected]);

    return (
        <div className="flex flex-col w-auto gap-2">
            {label && (
                <label className="block text-gray-700 text-sm font-bold" style={{ minWidth: 'fit-content' }}>
                    {label}
                </label>
            )}
            <select value={selectedOption.label} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                {options.map((option) => (
                    <option key={option.label} value={option.label}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Dropdown;
